import { CSSProperties } from 'react';
import {
  EdgeInterval,
  getVisibleEdgeSegments,
  getVisibleIntervalsPerEdge
} from 'utils/polygon-shared-edges';

type GridSpaceOutlineSvgProps = {
  vertices: { x: number; y: number }[];
  bboxWidth: number;
  bboxHeight: number;
  stroke: string;
  strokeWidth?: number;
  hiddenIntervalsPerEdge?: EdgeInterval[][];
  className?: string;
  style?: CSSProperties;
  segmentKeyPrefix?: string;
};

function GridSpaceOutlineSvg({
  vertices,
  bboxWidth,
  bboxHeight,
  stroke,
  strokeWidth = 2,
  hiddenIntervalsPerEdge,
  className = 'pointer-events-none absolute inset-0 h-full w-full',
  style,
  segmentKeyPrefix = 'polygon-overlay-edge'
}: GridSpaceOutlineSvgProps) {
  const visibleIntervals = hiddenIntervalsPerEdge
    ? getVisibleIntervalsPerEdge(hiddenIntervalsPerEdge)
    : vertices.map(() => [{ start: 0, end: 1 }]);
  const segments = getVisibleEdgeSegments(vertices, visibleIntervals);
  if (segments.length === 0) return null;

  return (
    <svg
      aria-hidden='true'
      className={className}
      style={style}
      viewBox={`0 0 ${bboxWidth} ${bboxHeight}`}
      preserveAspectRatio='none'
    >
      {segments.map((seg) => (
        <line
          key={`${segmentKeyPrefix}-${seg.p1.x}-${seg.p1.y}-${seg.p2.x}-${seg.p2.y}`}
          x1={seg.p1.x}
          y1={seg.p1.y}
          x2={seg.p2.x}
          y2={seg.p2.y}
          stroke={stroke}
          strokeWidth={strokeWidth}
          vectorEffect='non-scaling-stroke'
        />
      ))}
    </svg>
  );
}

export default GridSpaceOutlineSvg;
